import React from 'react'

export const IconLocation = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="currentColor" viewBox="0 0 100 100" {...props}>
      <path d="M54.42 91.333c-.762 0-1.48-.347-1.956-.943C51.36 89.003 25.42 56.2 25.42 37.666c0-15.99 13.01-29 29-29s29 13.01 29 29C83.42 56.16 57.482 89 56.377 90.39a2.504 2.504 0 01-1.957.943zm0-77.667c-13.233 0-24 10.767-24 24 0 14.04 17.954 39.043 24 47.063 6.043-8.027 24-33.057 24-47.064 0-13.233-10.767-24-24-24zm0 36.806c-7.062 0-12.806-5.744-12.806-12.806S47.358 24.86 54.42 24.86s12.806 5.744 12.806 12.806S61.48 50.472 54.42 50.472zm0-20.612c-4.304 0-7.806 3.502-7.806 7.806s3.502 7.806 7.806 7.806 7.806-3.502 7.806-7.806-3.502-7.806-7.806-7.806z" />
    </svg>
  )
}
